export enum Status {
  New = 'GP3V',
  Open = '7Qd/',
  Opened = 'sZ+4',
  Pending = 'MxVR',
  Canceled = 'E8ou',
  Rejected = 'rqSg',
  Submitted = 'ZJAE',
  Accepted = 'oA+w',
  Approved = 'h7Qu',
  approved = 'Jof4',
  Completed = 'Iqlw',
  Void = 'Tnuk',
  Voided = 'n5ri',
  voided = '32oG',
  CanceledAndVoid = '5xV6',
  NoStatusBrackets = 'NWb5',
  OpenDraftBrackets = 'HSmw',
  Saved = 'tcEg',
  saved = '2BxV',
  Reopened = 'U6Su',
  submitted = '4G+M',
  canceled = '8S/e',
  accepted = 'BwwW',
  rejected = 'IM2T',
  reopened = '0FCu',

  Replenished = 'TMua',
  completed = 'Tds+',
  open = 'I0j5',
  pending = 'YqL+',
  closed = 'w+77',
  Closed = 'wh6t',
}
